import React, { useState, useEffect } from "react";

import { adaptV4Theme } from '@mui/material/styles';

import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";

import Homepage from "./components/Homepage";
import Footer from "./components/Footer";
import firebase from "./firebase";
import StyleFirebaseUi from "react-firebaseui/StyledFirebaseAuth";

import "./App.css";

export const light = {
  palette: {
    mode: "light",
  },
};
export const dark = {
  palette: {
    mode: "dark",
  },
};

const uiConfig = {
  signInFlow: "popup",
  signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
  callbacks: {
    signInSuccessWithAuthResult: () => {
      return false;
    },
  },
};

function App() {
  const [theme, setTheme] = useState(localStorage.getItem('theme') ?? true);
  const [user, setUser] = useState(null);

  const appliedTheme = createTheme(adaptV4Theme(theme ? light : dark));

  useEffect(() => {
    const authObserver = firebase.auth().onAuthStateChanged((user) => {
      setUser(user);
    });
  });
  if (process.env.NODE_ENV === 'development' || user) {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={appliedTheme}>
          <div>
            <Homepage />
            <Footer />
          </div>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  } else {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={appliedTheme}>
        <div id="maincontainer1">
          <h1 className="head">Hash/Hub</h1>
          <h1 className="head2">Certificate Generator</h1>
          <div className="signin">
            <h1>Sign In</h1>
            <StyleFirebaseUi
              uiConfig={uiConfig}
              firebaseAuth={firebase.auth()}
              setuser={setUser}
              user={user}
            />
          </div>
        </div>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

export default App;
